import { Dispatch, SetStateAction } from "react";

interface TableClickArgs {
  keywordName: string;
  keywordId?: string;
  setSelectedBarData: Dispatch<SetStateAction<any>>;
  setPopupOpen: Dispatch<SetStateAction<boolean>>;
  searchParams: URLSearchParams;
  setSearchParams: Dispatch<SetStateAction<URLSearchParams>>;
  section: string;
  queryID: string;
}

export const handleTableClickPopupforBars = ({
  keywordName,
  keywordId,
  setSelectedBarData,
  setPopupOpen,
  searchParams,
  setSearchParams,
  section,
  queryID,
}: TableClickArgs) => {
  const selectedData = {
    source: keywordName,
    id: keywordId,
  };

  setSelectedBarData(selectedData);
  setPopupOpen(true);

  const updatedParams = new URLSearchParams(searchParams);
  updatedParams.set("section", section);
  updatedParams.set("queryID", queryID);
  setSearchParams(updatedParams);
};
